import React from 'react';
import { Target, Plus } from 'lucide-react';

interface EmptyStateProps {
  title?: string;
  description?: string;
  /** When provided, renders a primary CTA button */
  onNewAction?: () => void;
  ctaLabel?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = 'Nenhuma ação mapeada',
  description = 'Centralize e acompanhe as iniciativas de melhoria e tarefas estratégicas da sua operação para garantir a execução.',
  onNewAction,
  ctaLabel = 'Criar Nova Ação',
}) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-6 select-none">
      {/* Icon */}
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded border border-[var(--border-default)] bg-[var(--bg-elevated)]">
        <Target size={40} className="text-slate-300 dark:text-slate-600" strokeWidth={1} />
      </div>

      {/* Title */}
      <h3 className="mb-2 text-xl font-bold text-slate-700 dark:text-slate-200 text-center">
        {title}
      </h3>

      {/* Subtitle */}
      <p className="text-[13px] text-slate-500 dark:text-slate-400 text-center max-w-sm leading-relaxed">
        {description}
      </p>

      {/* CTA */}
      {onNewAction && (
        <button
          type="button"
          onClick={onNewAction}
          className="mt-6 inline-flex items-center gap-2 rounded bg-blue-600 px-5 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-blue-700 active:bg-blue-800"
        >
          <Plus size={16} />
          {ctaLabel}
        </button>
      )}
    </div>
  );
};

